import React from 'react'
import {
  Grid,
  FormControl,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@material-ui/core'
import '../../Style/crearFormularioElegibilidad.scss'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import NumberFormat from 'react-number-format'
import Table391 from '../Tables/TablesSec3/Table391'
import Table393 from '../Tables/TablesSec3/Table393'
import Table395 from '../Tables/TablesSec3/Table395'
import Table396 from '../Tables/TablesSec3/Table396'
import Table397 from '../Tables/TablesSec3/Table397'
import Table398 from '../Tables/TablesSec3/Table398'
import Table399 from '../Tables/TablesSec3/Table399'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'

const Accordion9 = ({ tableProductionandLoss }) => {
  const { EligibilityForm } = useFormElegibilidad()

  // Pregunta 9.4

  // const [ShowOther94, setShowOther94] = useState(false)
  // const [ShowOther92, setShowOther92] = useState(false)

  // useEffect(() => {
  //   if (EligibilityForm.FrOther) {
  //     setShowOther94(true)
  //   }
  //   if (EligibilityForm.TtOther) {
  //     setShowOther92(true)
  //   }
  // }, [])

  // TODO: Revisar que hace
  // useEffect(() => {
  //   if (EligibilityForm.FrCredits === false) {
  //     formik.setFieldValue('ReceivedCredits', 0)
  //   }
  // }, [EligibilityForm.FrCredits])

  // const handleOther92 = (e) => {
  //   if (e.target.checked === true) {
  //     setShowOther92(true)
  //     formik.setFieldValue('TtOther', true)
  //   } else {
  //     setShowOther92(false)
  //     formik.setFieldValue('TtOther', false)
  //   }
  // }

  // const handleOther94 = (e) => {
  //   console.log('valor', e.target.cheked)

  //   if (e.target.checked === true) {
  //     setShowOther94(true)
  //     formik.setFieldValue('FrOther', true)
  //   } else {
  //     setShowOther94(false)
  //     formik.setFieldValue('FrOther', false)
  //   }
  // }

  // const handleChangeTainingTechnical = (e) => {
  //   switch (e.target.value) {
  //     case 'AE':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('TtEnvironmental', true)
  //       } else {
  //         formik.setFieldValue('TtEnvironmental', false)
  //       }
  //       break

  //     case 'SO':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('TtSocial', true)
  //       } else {
  //         formik.setFieldValue('TtSocial', false)
  //       }
  //       break
  //     case 'FI':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('TtFinance', true)
  //       } else {
  //         formik.setFieldValue('TtFinance', false)
  //       }
  //       break
  //     case 'ME':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('TtMarketAccess', true)
  //       } else {
  //         formik.setFieldValue('TtMarketAccess', false)
  //       }
  //       break
  //     case 'IN':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('TtInnovation', true)
  //       } else {
  //         formik.setFieldValue('TtInnovation', false)
  //       }
  //       break

  //     default:
  //       formik.setValues({
  //         ...formik.values,
  //         TtEnvironmental: false,
  //         TtSocial: false,
  //         TtFinance: false,
  //         TtMarketAccess: false,
  //         TtInnovation: false,
  //       })

  //       break
  //   }
  // }

  // const handleChangeResourcesActivities = (e) => {
  //   switch (e.target.value) {
  //     case 'CR':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('FrCredits', true)
  //         formik.setFieldValue('ReceivedCredits', '')
  //       } else {
  //         formik.setFieldValue('FrCredits', false)
  //       }
  //       break

  //     case 'SB':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('FrSubsidies', true)
  //       } else {
  //         formik.setFieldValue('FrSubsidies', false)
  //       }
  //       break
  //     case 'DO':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('FrDonations', true)
  //       } else {
  //         formik.setFieldValue('FrDonations', false)
  //       }
  //       break
  //     case 'NP':
  //       if (e.target.checked === true) {
  //         setShowOther94(false)

  //         formik.setValues({
  //           ...formik.values,
  //           FrNotReceived: true,
  //           FrCredits: false,
  //           FrSubsidies: false,
  //           FrDonations: false,
  //           FrOther: false,
  //         })
  //       } else {
  //         formik.setFieldValue('FrNotReceived', false)
  //       }
  //       break
  //     case 'OT':
  //       if (e.target.checked === true) {
  //         setShowOther94(true)
  //         formik.setFieldValue('FrOther', true)
  //       } else {
  //         setShowOther94(false)
  //         formik.setFieldValue('FrOther', false)
  //       }
  //       break

  //     default:
  //       formik.setValues({
  //         ...formik.values,
  //         FrNotReceived: false,
  //         FrCredits: false,
  //         FrSubsidies: false,
  //         FrDonations: false,
  //         FrOther: false,
  //       })
  //       break
  //   }
  // }

  // const handleChangeResourcesUtilization = (e) => {
  //   switch (e.target.value) {
  //     case 'CT':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('RuWorkingCapital', true)
  //       } else {
  //         formik.setFieldValue('RuWorkingCapital', false)
  //       }
  //       break
  //     case 'CE':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('RuEquipmentPurchase', true)
  //       } else {
  //         formik.setFieldValue('RuEquipmentPurchase', false)
  //       }
  //       break
  //     case 'PR':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('RuPreinvestment', true)
  //       } else {
  //         formik.setFieldValue('RuPreinvestment', false)
  //       }
  //       break
  //     case 'CI':
  //       if (e.target.checked === true) {
  //         formik.setFieldValue('RuRealEstatePurchase', true)
  //       } else {
  //         formik.setFieldValue('RuRealEstatePurchase', false)
  //       }
  //       break

  //     default:
  //       formik.setValues({
  //         ...formik.values,
  //         RuWorkingCapital: false,
  //         RuEquipmentPurchase: false,
  //         RuPreinvestment: false,
  //         RuRealEstatePurchase: false,
  //       })

  //       break
  //   }
  // }

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          // sx={
          //   formik.errors.ClimaticInformation ||
          //   formik.errors.validTable391 ||
          //   formik.errors.RiskCommittees
          //     ? { border: '2px solid red' }
          //     : {}
          // }
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.1. Acceso a la información agroclimática
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/** pregunta 1 */}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1. ¿Las MIPYME / miembros o asociados dentro de las MIPYME,
                consultan y acceden a información agroclimática?{' '}
                <a
                  data-tip="Se refiere a información sobre el clima en la zona del proyecto."
                  data-for="info91Pop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="info91Pop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
                <br></br>
                <br></br>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  name="ClimaticInformation"
                  value={EligibilityForm.ClimaticInformation}
                  // onChange={(e) => {
                  //   if (e.target.value === 'true') {
                  //     formik.setFieldValue('ClimaticInformation', true)
                  //   } else {
                  //     formik.setFieldValue('ClimaticInformation', false)
                  //   }
                  // }}
                  disabled
                  row
                >
                  <FormControlLabel
                    value={true}
                    disabled
                    control={<Radio />}
                    label="Si"
                  />
                  <FormControlLabel
                    value={false}
                    disabled
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          {/** pregunta 2 */}
          {EligibilityForm.ClimaticInformation && (
            <Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  2. ¿Cómo planifica usted sus actividades productivas ante
                  amenazas climáticas?
                </label>
                <br></br>
                <br></br>
              </Grid>
              {/* TABLE */}
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <Table391
                    idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                    // formik={formik}
                  ></Table391>
                </Grid>
              </Grid>
              {/** pregunta 3 */}

              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    3. ¿Participa la MIPYME en los comités locales de riesgo
                    climático (o su equivalente local)?{' '}
                    <a
                      data-tip="
                    Los comités locales de riesgo son aquellos
                    conformados por las comunidades, y que
                      pasan a integrar los comités municipales en
                       caso de emergencia."
                      data-for="info913Pop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="info913Pop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                    <br></br>
                    <br></br>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <RadioGroup
                      id="RiskCommittees"
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group-rickCommittee"
                      disabled
                      value={EligibilityForm.RiskCommittees}
                      row
                    >
                      <FormControlLabel
                        value={true}
                        disabled
                        control={<Radio />}
                        label="Si"
                      />
                      <FormControlLabel
                        value={false}
                        disabled
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          // sx={
          //   formik.errors.IdTechnicalTraining ||
          //   formik.errors.IdTechnicalTrainingFrec ||
          //   formik.errors.totalMembers ||
          //   formik.errors.TechnicalTrainingMen ||
          //   formik.errors.totalEmployes ||
          //   formik.errors.TechnicalTrainingEmplWomen ||
          //   formik.errors.TechnicalTrainingEmplMen ||
          //   formik.errors.TechnicalTrainingManager
          //     ? { border: '2px solid red' }
          //     : {}
          // }
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.2. Capacitación y asistencia técnica{' '}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/** pregunta 1 */}
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1. ¿Ha recibido capacitación, asistencia técnica o ambas, en
                medidas de adaptación al cambio climático, el año pasado?{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="idT"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  // onChange={(e) => {
                  //   formik.setFieldValue(
                  //     'IdTechnicalTraining',
                  //     e.target.value,
                  //   )
                  // }}
                  disabled
                  value={EligibilityForm.IdTechnicalTraining}
                >
                  <FormControlLabel
                    value="NO"
                    disabled
                    control={<Radio />}
                    label="No"
                  />
                  <FormControlLabel
                    value="CP"
                    disabled
                    control={<Radio />}
                    label="Capacitación"
                  />
                  <FormControlLabel
                    value="AT"
                    disabled
                    control={<Radio />}
                    label="Asistencia Técnica"
                  />
                  <FormControlLabel
                    value="AB"
                    disabled
                    control={<Radio />}
                    label="Ambas"
                  />
                </RadioGroup>
              </FormControl>

              {/** pregunta 2 */}

              {EligibilityForm.IdTechnicalTraining !== 'NO' ? (
                <div>
                  <Grid container spacing={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          2. ¿Con que frecuencia han recibido la capacitación,
                          asistencia técnica, o ambas en medidas de adaptación
                          al cambio climático, el año pasado?{' '}
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <RadioGroup
                            id="isNativeCommunity"
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            disabled
                            // onChange={(e) => {
                            //   formik.setFieldValue(
                            //     'IdTechnicalTrainingFrec',
                            //     e.target.value,
                            //   )
                            // }}
                            value={EligibilityForm.IdTechnicalTrainingFrec}
                          >
                            <FormControlLabel
                              value="UV"
                              control={<Radio />}
                              label="Una vez"
                              disabled
                            />
                            <FormControlLabel
                              value="MV"
                              control={<Radio />}
                              label="Más de una vez"
                              disabled
                            />
                            <FormControlLabel
                              value="FR"
                              control={<Radio />}
                              label="Frecuentemente"
                              disabled
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>

                    {/** pregunta 3 */}
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          3. ¿Cuántos miembros/asociados y empleados,
                          desagregados por género, han participado en
                          capacitaciones sobre cambio climático y conocen las
                          soluciones de adaptación adecuadas?{' '}
                        </label>
                      </Grid>
                      <Grid container spacing={1}>
                        {/* MUJERES */}
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={6}
                          style={{ marginTop: '3%' }}
                        >
                          <label className="responsiveLabel">
                            Mujeres:
                            <a
                              data-tip="
                  Indique el número de mujeres
                  (miembros/socias) que participaron en
                  dichos eventos."
                              data-for="info922Pop"
                              style={{ cursor: 'pointer' }}
                            >
                              <ErrorOutlineIcon fontSize="small" />
                              <ReactTooltip
                                id="info922Pop"
                                effect="solid"
                                multiline={true}
                                type="dark"
                              />
                            </a>
                            <br></br>
                            <br></br>
                          </label>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={6}
                          style={{ marginTop: '3%' }}
                        >
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="womenSociety"
                              style={{ width: '100%' }}
                              // error={formik.errors.womenSociety}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              // onChange={(e) => {
                              //   formik.setFieldValue(
                              //     'TechnicalTrainingWomen',
                              //     Number(e.target.value),
                              //   )
                              // }}
                              // disabled={
                              //   EligibilityForm.MiPymeType ===
                              //   'Persona Natural'
                              // }
                              disabled
                              value={EligibilityForm.TechnicalTrainingWomen}
                            />
                          </FormControl>
                        </Grid>
                        {/** HOMBRES */}
                        <Grid item xs={6} sm={6} md={6}>
                          <label className="responsiveLabel">
                            Hombres:
                            <a
                              data-tip="
                        Indique el número de hombres
                        (miembros/socios) que participaron en
                        dichos eventos."
                              data-for="info9222Pop"
                              style={{ cursor: 'pointer' }}
                            >
                              <ErrorOutlineIcon fontSize="small" />
                              <ReactTooltip
                                id="info9222Pop"
                                effect="solid"
                                multiline={true}
                                type="dark"
                              />
                            </a>
                            <br></br>
                            <br></br>
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="menSociety"
                              style={{ width: '100%' }}
                              // error={formik.errors.menSociety}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              // onChange={(e) => {
                              //   formik.setFieldValue(
                              //     'TechnicalTrainingMen',
                              //     Number(e.target.value),
                              //   )
                              // }}
                              // disabled={
                              //   EligibilityForm.MiPymeType ===
                              //   'Persona Natural'
                              // }
                              disabled
                              value={EligibilityForm.TechnicalTrainingMen}
                            />
                          </FormControl>
                        </Grid>
                        {/* Miembros */}
                        <Grid item xs={6} sm={6} md={6}>
                          <label className="responsiveLabel">
                            Total Miembros / Asociados:
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id=""
                              style={{ width: '100%' }}
                              // error={formik.errors.totalMembers}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              // onChange={(e) => {
                              //   formik.setFieldValue(
                              //     'totalMembers',
                              //     e.target.value,
                              //   )
                              // }}
                              disabled
                              value={
                                EligibilityForm.TechnicalTrainingWomen +
                                EligibilityForm.TechnicalTrainingMen
                              }
                            />
                          </FormControl>
                        </Grid>
                        <br></br>
                        <br></br>
                        <br></br>

                        {/* MUJERES */}
                        <Grid item xs={6} sm={6} md={6}>
                          <label className="responsiveLabel">
                            Mujeres:
                            <a
                              data-tip="
                        Indique el número de mujeres empleadas
                        que participaron en dichos eventos."
                              data-for="info9222Pop"
                              style={{ cursor: 'pointer' }}
                            >
                              <ErrorOutlineIcon fontSize="small" />
                              <ReactTooltip
                                id="info9222Pop"
                                effect="solid"
                                multiline={true}
                                type="dark"
                              />
                            </a>
                            <br></br>
                            <br></br>
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="womenEmployees"
                              style={{ width: '100%' }}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              // onChange={(e) => {
                              //   formik.setFieldValue(
                              //     'TechnicalTrainingEmplWomen',
                              //     Number(e.target.value),
                              //   )
                              // }}
                              disabled
                              value={EligibilityForm.TechnicalTrainingEmplWomen}
                              allowNegative={false}
                              inputProps={{ maxLength: 3 }}
                              decimalScale={0}
                            />
                          </FormControl>
                        </Grid>
                        {/** HOMBRES */}
                        <Grid item xs={6} sm={6} md={6}>
                          <label className="responsiveLabel">
                            Hombres:
                            <a
                              data-tip="
                        Indique el número de hombres empleados
                        que participaron en dichos eventos."
                              data-for="info9222Pop"
                              style={{ cursor: 'pointer' }}
                            >
                              <ErrorOutlineIcon fontSize="small" />
                              <ReactTooltip
                                id="info9222Pop"
                                effect="solid"
                                multiline={true}
                                type="dark"
                              />
                            </a>
                            <br></br>
                            <br></br>
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="menEmployees"
                              style={{ width: '100%' }}
                              // error={formik.errors.TechnicalTrainingEmplMen}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              // onChange={(e) => {
                              //   formik.setFieldValue(
                              //     'TechnicalTrainingEmplMen',
                              //     Number(e.target.value),
                              //   )
                              // }}
                              disabled
                              value={EligibilityForm.TechnicalTrainingEmplMen}
                              allowNegative={false}
                              inputProps={{ maxLength: 3 }}
                              decimalScale={0}
                            />
                          </FormControl>
                        </Grid>
                        {/* Empleados */}
                        <Grid item xs={6} sm={6} md={6}>
                          <label className="responsiveLabel">
                            Total Empleados:
                          </label>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="totalEmployes"
                              style={{ width: '100%' }}
                              // error={formik.errors.totalEmployes}
                              customInput={TextField}
                              thousandSeparator={true}
                              variant="outlined"
                              disabled
                              value={
                                EligibilityForm.TechnicalTrainingEmplWomen +
                                EligibilityForm.TechnicalTrainingEmplMen
                              }
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/** pregunta 4 */}
                  <Grid container spacing={1}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{ marginTop: '3%' }}
                    >
                      <label className="responsiveLabel">
                        4. ¿Quién le brindó la capacitación o asistencia
                        técnica?{' '}
                      </label>
                    </Grid>
                    <Grid container spacing={1}>
                      <FormControl style={{ width: '100%' }}>
                        <TextField
                          id="TechnicalTrainingManager"
                          style={{ width: '100%', marginBottom: '15px' }}
                          variant="outlined"
                          disabled
                          // onChange={(e) => {
                          //   formik.setFieldValue(
                          //     'TechnicalTrainingManager',
                          //     e.target.value,
                          //     false,
                          //   )
                          // }}
                          value={EligibilityForm.TechnicalTrainingManager}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>

                  {/** pregunta 5 */}
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        5. Enumere los temas sobre los que ha recibido
                        capacitación o asistencia técnica?
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="AE"
                              checked={!!EligibilityForm.TtEnvironmental}
                              disabled
                            />
                          }
                          label="Ambientales"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="SO"
                              checked={!!EligibilityForm.TtSocial}
                              // onChange={(e) => handleChangeTainingTechnical(e)}
                              disabled
                            />
                          }
                          label="Sociales"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="FI"
                              checked={!!EligibilityForm.TtFinance}
                              // onChange={(e) => handleChangeTainingTechnical(e)}
                              disabled
                            />
                          }
                          label="Finanzas"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="ME"
                              checked={!!EligibilityForm.TtMarketAccess}
                              // onChange={(e) => handleChangeTainingTechnical(e)}
                              disabled
                            />
                          }
                          label="Acceso a mercados"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="IN"
                              checked={!!EligibilityForm.TtInnovation}
                              // onChange={(e) => handleChangeTainingTechnical(e)}
                              disabled
                            />
                          }
                          label="Innovación"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              value="Others"
                              checked={!!EligibilityForm.TtOther}
                              // onChange={(e) => handleOther92(e)}
                              disabled
                            />
                          }
                          label="Otros"
                        />
                      </FormGroup>
                      {/* {ShowOther92 && ( */}
                      <Grid container spacing={1} className="input__container">
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={12} md={12}>
                            <FormControl style={{ width: '100%' }}>
                              <TextField
                                id="TtOther"
                                style={{ width: '100%' }}
                                // error={formik.errors.TtDetail}
                                variant="outlined"
                                // onChange={(e) => {
                                //   formik.setFieldValue(
                                //     'TtDetail',
                                //     e.target.value,
                                //   )
                                // }}
                                disabled
                                value={EligibilityForm.TtDetail}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      {/* )} */}
                    </Grid>
                  </Grid>
                </div>
              ) : null}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          // sx={formik.errors.validTable393 ? { border: '2px solid red' } : {}}
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.3. Barreras para acceder a los mercados
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Marque en cada caso, lo que mejor describa la situación de la
                MIPYME, incluyendo a los miembros/asociados dentro de ella:{' '}
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table393
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  // formik={formik}
                ></Table393>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          // sx={
          //   formik.errors.FrDetail || formik.errors.ReceivedCredits
          //     ? { border: '2px solid red' }
          //     : {}
          // }
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.4. Barreras Financieras
            <a
              data-tip="
                          Se refiere a obstáculos que la MIPYME ha
                          encontrado, para acceder recursos
                          financieros (créditos)."
              data-for="info94Pop"
              style={{ cursor: 'pointer' }}
            >
              <ErrorOutlineIcon fontSize="small" />
              <ReactTooltip
                id="info94Pop"
                effect="solid"
                multiline={true}
                type="dark"
              />
            </a>
            <br></br>
            <br></br>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {/** pregunta 1 */}
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1. ¿Qué tipo de recursos ha recibido la MIPYME anteriormente
                para utilizarlos en actividades productivas?{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="NP"
                      disabled
                      checked={EligibilityForm.FrNotReceived === true}
                      // onChange={(e) => handleChangeResourcesActivities(e)}
                    />
                  }
                  label="La MIPYME nunca ha percibido recursos de este tipo"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="CR"
                      // disabled={EligibilityForm.FrNotReceived}
                      disabled
                      // onChange={(e) => handleChangeResourcesActivities(e)}
                      checked={EligibilityForm.FrCredits === true}
                    />
                  }
                  label="Créditos"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="SB"
                      // disabled={EligibilityForm.FrNotReceived}
                      disabled
                      // onChange={(e) => handleChangeResourcesActivities(e)}
                      checked={EligibilityForm.FrSubsidies === true}
                    />
                  }
                  label="Subsidios"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="DO"
                      // disabled={EligibilityForm.FrNotReceived}
                      disabled
                      // onChange={(e) => handleChangeResourcesActivities(e)}
                      checked={EligibilityForm.FrDonations === true}
                    />
                  }
                  label="Donaciones"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      value="OT"
                      // disabled={EligibilityForm.FrNotReceived}
                      disabled
                      // onChange={(e) => handleOther94(e)}
                      checked={EligibilityForm.FrOther === true}
                    />
                  }
                  label="Otros, describir"
                />
              </FormGroup>
              {/* {ShowOther94 && ( */}
              <Grid container spacing={1} className="input__container">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <TextField
                        id="Others94"
                        style={{ width: '100%' }}
                        // error={!!formik.errors.FrDetail}
                        variant="outlined"
                        // onChange={(e) => {
                        //   formik.setFieldValue('FrDetail', e.target.value)
                        // }}
                        disabled
                        value={EligibilityForm.FrDetail}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              {/* )} */}
            </Grid>
          </Grid>

          {/* pregunta 2 */}
          <Grid container spacing={3} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                2. ¿Cuántos créditos ha recibido?
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="creditsReceived"
                  style={{ width: '100%' }}
                  // error={!!formik.errors.ReceivedCredits}
                  variant="outlined"
                  customInput={TextField}
                  thousandSeparator={true}
                  // disabled={!EligibilityForm.FrCredits}
                  defaultValue={
                    EligibilityForm.FrCredits
                      ? ''
                      : EligibilityForm.ReceivedCredits
                  }
                  disabled
                  value={EligibilityForm.ReceivedCredits}
                  // onChange={(e) => {
                  //   formik.setFieldValue(
                  //     'ReceivedCredits',
                  //     parseInt(e.target.value.replaceAll(',', '')),
                  //   )
                  // }}
                  inputProps={{ maxLength: 3 }}
                  decimalScale={0}
                  allowNegative={false}
                />
              </FormControl>
            </Grid>
          </Grid>

          {/** pregunta 3 */}
          <Grid container spacing={3} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                3. ¿En qué fueron utilizados los recursos?{' '}
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="CT"
                      checked={!!EligibilityForm.RuWorkingCapital}
                      // onChange={(e) => handleChangeResourcesUtilization(e)}
                    />
                  }
                  label="Capital de trabajo"
                  // disabled={EligibilityForm.FrNotReceived}
                  disabled
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="CE"
                      checked={!!EligibilityForm.RuEquipmentPurchase}
                      // onChange={(e) => handleChangeResourcesUtilization(e)}
                    />
                  }
                  label="Compra de equipos u otros bienes y muebles"
                  // disabled={EligibilityForm.FrNotReceived}
                  disabled
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="PR"
                      checked={!!EligibilityForm.RuPreinvestment}
                      // onChange={(e) => handleChangeResourcesUtilization(e)}
                    />
                  }
                  label="Preinversión"
                  // disabled={EligibilityForm.FrNotReceived}
                  disabled
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      value="CI"
                      checked={!!EligibilityForm.RuRealEstatePurchase}
                      // onChange={(e) => handleChangeResourcesUtilization(e)}
                    />
                  }
                  label="Compra de inmueble"
                  // disabled={EligibilityForm.FrNotReceived}
                  disabled
                />
              </FormGroup>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.5. Acceso de la MIPYME a servicios de energía, teléfono e
            internet
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Seleccione el (los) servicio(os) al (a los) que la MIPYME tiene
                acceso:{' '}
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table395
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  MiPymeType={EligibilityForm.MiPymeType}
                  men={EligibilityForm.MenCount}
                  women={EligibilityForm.WomenCount}
                ></Table395>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.6. Energía para la producción
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Seleccione el tipo de energía que en general utiliza la MIPYME
                en sus actividades productivas:{' '}
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table396
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                ></Table396>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          // sx={formik.errors.validTable397 ? { border: '2px solid red' } : {}}
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.7. Sistema de riego utilizado por la MIPYME
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Seleccione el tipo riego que en general utiliza la MIPYME en sus
                actividades productivas (plica solo para: Agroforestería y
                Agricultura Orgánica):{' '}
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table397
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  tableProductionandLoss={tableProductionandLoss}
                  // formik={formik}
                ></Table397>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          // sx={formik.errors.validTable398 ? { border: '2px solid red' } : {}}
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.8. Fertilizantes y pesticidas utilizadas por la MIPYME
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Seleccione el tipo de fertilizante y pesticidas que en general
                utiliza la MIPYME en sus actividades productivas (Aplica solo
                para: Agroforesteria y Agricultura Orgánica):{' '}
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table398
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  tableProductionandLoss={tableProductionandLoss}
                  // formik={formik}
                ></Table398>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          // sx={formik.errors.validTable399 ? { border: '2px solid red' } : {}}
        >
          <Typography sx={{ fontWeight: 'bold' }}>
            3.9.9. Prácticas para el uso y manejo sostenible
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Seleccione la(s) práctica(s) o tecnología(s) de gestión
                sostenible del suelo. Indique si la MIPYME o MIPYME asociativa
                ha implementado este tipo de prácticas. En caso de MIPYME
                asociativas, definir cuántos de sus miembros / asociados han
                implementado cada una de ellas
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table399
                  idElegibilityForm={EligibilityForm.IdElegibilityAnswer}
                  // formik={formik}
                ></Table399>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default Accordion9
